/**
 * Reusable validation rule helper functions.
 * Each helper returns a rule object: { check: Function, message: String, validateOnChange?: Boolean }
 */

/**
 * Validates that a value is not empty/null/undefined.
 * By default, this runs on change to show errors immediately when cleared.
 */
export const required = (message) => ({
  check: (val) => {
    if (typeof val === 'string') return !!val.trim();
    if (Array.isArray(val)) return val.length > 0;
    return val !== undefined && val !== null && val !== '';
  },
  message,
  validateOnChange: true,
});

/**
 * Validates email pattern.
 */
export const email = (message) => ({
  check: (val) => !val || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val),
  message,
});

/**
 * Validates a 10-digit mobile number.
 */
export const mobile = (message) => ({
  check: (val) => !val || /^\d{10}$/.test(val.trim()),
  message,
});

/**
 * Validates minimum string length.
 */
export const minLength = (length, message) => ({
  check: (val) => !val || val.length >= length,
  message,
});

/**
 * Validates that this field matches another field in the form.
 */
export const matchField = (targetField, message) => ({
  check: (val, values) => val === values[targetField],
  message,
});

/**
 * Validates value against a custom regex pattern.
 */
export const pattern = (regex, message) => ({
  check: (val) => !val || regex.test(val),
  message,
});

/**
 * Allows passing a custom predicate function.
 */
export const custom = (checkFn, message, validateOnChange = false) => ({
  check: checkFn,
  message,
  validateOnChange,
});
